import React from "react";

import Image from "components/atoms/Image";
import "./index.scss";
import Icon, { IconName } from "components/atoms/Icon";

interface ProductfeatureProps {
  imgSrc?: string;
  iconName?: IconName;
  title?: string;
  description: string;
}

const Productfeature: React.FC<ProductfeatureProps> = ({
  imgSrc,
  title,
  description,
  iconName,
}) => {
  return (
    <div className="m-productfeature">
      <div className="m-productfeature_image">
        {imgSrc && <Image src={imgSrc} alt={title || description} />}
        {iconName && <Icon iconName={iconName} />}
      </div>
      <div className="m-productfeature_tooltip">
        {title && <div className="m-productfeature_tooltip-title">{title}</div>}
        <div className="m-productfeature_tooltip-description">
          <label
            dangerouslySetInnerHTML={{
              __html: description || "",
            }}
          />
        </div>
      </div>
    </div>
  );
};

Productfeature.defaultProps = {};

export default Productfeature;
